import { render, staticRenderFns } from "./IconCloseBold.vue?vue&type=template&id=572fd49a"
import script from "./IconCloseBold.vue?vue&type=script&lang=js"
export * from "./IconCloseBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports